const ENDPOINT = '/egcs/v2/collect';
const REQUIRED_PAYLOAD_FIELDS = ['event', 'experience'];
const REQUIRED_EVENT_FIELDS = ['event_version', 'event_name', 'event_type'];
const REQUIRED_EXPERIENCE_FIELDS = ['page_name', 'app_name', 'app_version'];
const EXPERIENCE_TYPE_WEB = 'Web';
const ERRORS = {
    INVALID_PAYLOAD_ERROR: 'onInvalidPayload',
    PUBLISH_ERROR: 'onPublishError',
    FETCH_ERROR: 'onFetchError',
};
export {
    ENDPOINT,
    REQUIRED_PAYLOAD_FIELDS,
    REQUIRED_EVENT_FIELDS,
    REQUIRED_EXPERIENCE_FIELDS,
    EXPERIENCE_TYPE_WEB,
    ERRORS,
};
